const { getElement, debounce } = window.BAO.Utils

export class SiteDrawer extends window.BAO.CustomElement({
  SuperClass: HTMLDialogElement,
}) {
  constructor () {
    super()
    this._isOpen = false
  }

  connectedCallback () {
    super.connectedCallback()

    this.drawers = getElement('site-drawers')
    if (!this.drawers) {
      throw new Error(
        `${this.nodeName.toLowerCase()} needs a <site-drawers> element to work`,
      )
    }
    this.drawers.drawers.push(this)

    if (this.drawerShouldBeMoved) {
      window.setTimeout(
        () => {
          const moveToElement = this.moveToElement
          this.removeAttribute('data-module-drawers-move-me')
          moveToElement.appendChild(this)
        },
        parseInt(this.getAttribute('data-module-drawers-move-delay'), 10) || 0,
      )
    }
  }

  setupListeners () {
    super.setupListeners()

    if (
      this.querySelector('[data-site-drawer-el="transparent-header"]') &&
      this.querySelector('[data-site-drawer-el="inner"]')
    ) {
      this.listeners.add(
        this.querySelector('[data-site-drawer-el="inner"]'),
        'scroll',
        debounce(this.handleScroll.bind(this), 100),
      )
    }
  }

  handleScroll () {
    this.classList.toggle(
      'drw-Drawer-scrolled',
      this.querySelector('[data-site-drawer-el="inner"]').scrollTop > 100,
    )
  }

  get key () {
    return this.getAttribute('key')
  }

  get elements () {
    return {
      trigger: getElement(`[data-drawers-trigger=${this.key}]`),
      close: getElement(`[data-module-drawers-close=${this.key}]`),
    }
  }

  get isOpen () {
    return this._isOpen
  }

  set isOpen (val) {
    this._isOpen = val

    this.classList.toggle(this.config.classes.activeDrawerClass, val)

    if (val) {
      if (!this.hasAttribute('open')) {
        this.showModal()
      }
    } else {
      if (this.hasAttribute('open')) {
        this.close()
      }
    }
  }

  get drawerShouldBeMoved () {
    return this.hasAttribute('data-module-drawers-move-me')
  }

  get moveToElement () {
    switch (this.getAttribute('data-module-drawers-move-me')) {
      case 'root':
        return this.drawers
      default:
        return getElement(this.getAttribute('data-module-drawers-move-me'))
    }
  }

  get config () {
    return {
      classes: {
        activeDrawerClass: 'drw-Drawer-active',
      },
    }
  }
}

customElements.define('site-drawer', SiteDrawer, { extends: 'dialog' })
